import { useEffect } from "react";

import { usePaymentMethodState } from "./";

import API from "./API";

export default function DeletePaymentMethod() {
  const {
    setState,
    deleting,
    onDeleteSuccess,
    //post data
    paymentMethodID,
    userID,
  } = usePaymentMethodState();

  useEffect(() => {
    if (!deleting) return;
    const deleteCall = API.deleteSavedPaymentMethod({
      userID,
      paymentMethodID,
    });

    deleteCall
      .post()
      .then((resp) => {
        setState({ deleting: false, isDeleted: true });
        if (onDeleteSuccess) onDeleteSuccess(resp);
      })
      .catch((err) => {
        setState({ deleting: false });
        console.log({ err });
      });

    return () => deleteCall.cancel();
  }, [deleting, paymentMethodID, onDeleteSuccess, setState, userID]);

  return null;
}
